export default __webpack_public_path__ + "static/media/9loch_scorekarte.ce0bb4f9.jpg";